import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("mz_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("mz_token");
      localStorage.removeItem("mz_user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

// Arabic field labels for Pydantic validation errors.
const AR_FIELD_LABELS = {
  name: "الاسم",
  phone: "رقم الجوال",
  phones: "أرقام الجوال",
  whatsapp: "رقم الواتساب",
  whatsapp_phone: "رقم الواتساب",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  company_name: "اسم الشركة",
  cr_number: "السجل التجاري",
  commercial_register_number: "السجل التجاري",
  contact_name: "اسم المسؤول",
  contact_person_name: "اسم المسؤول",
  car_type: "نوع السيارة",
  license_plate: "رقم اللوحة",
  note: "الملاحظات",
  notes: "الملاحظات",
  access_code: "رمز الدخول",
  passengers: "عدد الركاب",
  quantity: "عدد السيارات",
  pickup_location: "نقطة الانطلاق",
  destination: "الوجهة",
  trip_date: "التاريخ",
  trip_time: "الوقت",
  total_price: "السعر الإجمالي",
  base_price: "السعر الأساسي",
  status: "الحالة",
  company_id: "الشركة",
  client_name: "اسم العميل",
  client_phone: "جوال العميل",
  flight_number: "رقم الرحلة",
  flight_airline: "شركة الطيران",
  display_order: "ترتيب العرض",
};

function translatePydanticError(detail) {
  if (!Array.isArray(detail) || detail.length === 0) return null;
  const first = detail[0] || {};
  const loc = Array.isArray(first.loc) ? first.loc : [];
  // Skip the leading "body" / "query" segment.
  const rawField = String(loc.filter((s) => s !== "body" && s !== "query").pop() || "");
  const label = AR_FIELD_LABELS[rawField] || rawField;
  const type = first.type || "";
  const ctx = first.ctx || {};
  if (type === "missing") return `الحقل مطلوب: ${label}`;
  if (type === "string_too_short") {
    const min = ctx.min_length;
    return `${label} قصير جداً${min ? ` (يجب ${min} أحرف على الأقل)` : ""}`;
  }
  if (type === "string_too_long") {
    const max = ctx.max_length;
    return `${label} طويل جداً${max ? ` (الحد الأقصى ${max})` : ""}`;
  }
  if (type === "int_parsing" || type === "float_parsing") return `${label} يجب أن يكون رقماً`;
  if (type === "greater_than_equal") return `${label} يجب أن يكون ≥ ${ctx.ge ?? 0}`;
  if (type === "less_than_equal") return `${label} يجب أن يكون ≤ ${ctx.le ?? 0}`;
  if (type === "value_error" || type === "string_pattern_mismatch") return `${label} غير صحيح`;
  if (type === "literal_error") return `${label} غير صحيح`;
  return first.msg ? `${label}: ${first.msg}` : `بيانات غير صحيحة (${label})`;
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return translatePydanticError(d) || d.map((e) => e?.msg || JSON.stringify(e)).join(" · ");
  }
  if (d?.msg) return d.msg;
  return err?.message || "حدث خطأ ما";
}

export default api;
